import { render, staticRenderFns } from "./SfSearchBar.vue?vue&type=template&id=2b93b22c"
import script from "./SfSearchBar.vue?vue&type=script&lang=js"
export * from "./SfSearchBar.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./SfSearchBar.vue?vue&type=style&index=0&id=2b93b22c&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "65a5eab8"
  
)

export default component.exports